import { React, useContext, useEffect, useState, useRef } from "react";
import { Tabs, SpinLoading } from 'antd-mobile'
import { UserContext } from 'utils/getContext'
import loginOut from "static/images/loginOut.svg";
import { ApplyResultCard } from "./ApplyResultCard";
import { BpmTabBar } from "components/TabBar/BpmTabBar";
import { BpmLoginCardContent } from "components/HomeLoginCardContent/BpmLoginCardContent"
import { postPersonCenter } from "api/api";
// import { postPersonCenter, infoLoginOut } from "api/api";
import { reviewType } from "utils/constant";
import BpmToast from "components/BpmToast";
import "static/css/mine.css"

const { SUCCESS, FAIL, ING } = reviewType

/** 我的 */
export function Mine() {
  const myContext = useContext(UserContext)
  const { userInfo, setUserInfo, loginInfo } = myContext
  const [scrollNum, setScrollNum] = useState(1) //页码
  const [hasMore, setHasMore] = useState(false) //是否执行上拉加载
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([])
  const headerRef = useRef()

  const parm = userInfo ? {
    id: userInfo.idNum,
    status: undefined,
    pageIndex: scrollNum,
    pageSize: 10,
  } : {}

  //判断用户是否登录
  useEffect(() => {
    userInfo && getList(parm)
    if (!userInfo) {
      setList([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  //列表初次加载与下拉刷新
  async function getList(params) {
    setLoading(true)
    const { code, data, msg } = await postPersonCenter({ ...params, pageIndex: 1 })
    if (code === 200) {
      setScrollNum(2)
      setList(data.list)
      setHasMore(data.list.length > 0)
      setLoading(false)
    } else {
      setLoading(false)
      BpmToast(msg || '加载数据失败')
    }
  }

  //列表上拉加载
  async function toFiniteScroll(params) {
    const { code, data, msg } = await postPersonCenter(params)
    if (code === 200) {
      setScrollNum(scrollNum + 1)
      setList([...list, ...data.list])
      setHasMore(data.list.length > 0)
    } else {
      BpmToast(msg || '加载数据失败')
    }
  }

  // TabsTab(title, key, 1 & 2 & 3)
  //显示用户申请信息
  function TabsTab(title, key, type) {
    return (
      <Tabs.Tab title={title} key={key}>
        {
          loading ?
            <div className='loading'>
              <SpinLoading className="spinLoading" />
            </div>
            :
            <ApplyResultCard
              list={
                type === 'all' ? (
                  list
                ) : (
                  list.filter(item => item.resultflag === type)
                )
              }
              ScrollList={() => toFiniteScroll(parm)}
              hasMore={hasMore}
              toRefresh={() => getList(parm)}
              loading={loading} />
        }
      </Tabs.Tab>
    )
  }

  //退出登录
  function handleOutLoginClick() {
    // 从loginInfo中
    // infoLoginOut()
    const {
      appLogoutReturnUrl, loginoutUrl, loginoutParams } = loginInfo
    /**登出地址 */
    const logoutUrl
      = `${loginoutUrl}`
    setUserInfo(null)
    localStorage.setItem("user", null)
    window.location.href = logoutUrl
  }

  //退出登录按钮
  const loginSuccessBut = (userInfo) => {
    if (userInfo) {
      return (<button onClick={handleOutLoginClick} className='outLoginBut'>
        <img className='headerAreaImg' src={loginOut} alt='退出登录'></img>
        退出登录
      </button>)
    }
    else {
      return null
    }
  }

  //查看申请部分高度自适应
  useEffect(() => {
    const style = document.createElement('style')
    style.type = 'text/css'
    style.textContent = `
      .tabs{
        height: calc(100vh - ${headerRef.current.getBoundingClientRect().height}px - 50px);
      }
    `
    document.head.appendChild(style)
  }, []);

  return (
    <div className="mine">
      {/* 用户信息区域 */}
      <div className="mineHeader" ref={headerRef}>
        <div className="headerArea">
          <BpmLoginCardContent userInfo={userInfo} />
        </div>
        {
          loginSuccessBut(userInfo)
        }
      </div>
      {/* 申请信息区域 */}
      <Tabs className='tabsTab'>
        {TabsTab('全部', 'fruits', 'all')}
        {TabsTab('审核中', 'vegetables', ING)}
        {TabsTab('审核通过', 'animals', SUCCESS)}
        {TabsTab('审核驳回', 'stop', FAIL)}
      </Tabs>
      {/* 底部导航栏 */}
      <BpmTabBar />
    </div>
  )
}